import EzController from 'controllers/ez-base-controller';
import {
  triggerCustomEvent,
} from 'lib/helpers';
import Cookies from 'js-cookie';
import { saveToLocalAndCookie, addSessionViewActivity } from 'lib/sessions-manager';
import events from 'lib/events';
import { initTooltips } from 'ez-styles/assets/js/utils/tooltips';

export default class ResourceShowMainController extends EzController {
  static targets = [
    'sidebar',
    'title',
  ];

  connect() {
    addSessionViewActivity(this.element.dataset.resourceId);
    saveToLocalAndCookie('most_recent_resource_id', this.element.dataset.resourceId);

    if (this.element.dataset.autodlPath) this.triggerResourceDownload();

    if (document.querySelector('[data-ez-tooltip="true"]')) {
      initTooltips();
    }
  }

  triggerResourceDownload() {
    const downloadSize = Cookies.get('download_size_for_checkout') || 'original';

    if (downloadSize !== 'original' && document.querySelector(`[data-controller="download-btn"][data-size="${downloadSize}"]`)) {
      setTimeout(() => { // set a timeout so the download button controller has a chance to initialize
        document.querySelector(`[data-controller="download-btn"][data-size="${downloadSize}"]`).click();
      }, 500);
    } else {
      window.location = this.element.dataset.autodlPath;
    }

    Cookies.remove('download_size_for_checkout');
  }

  contributorClick() {
    triggerCustomEvent(events.show_page.contributor_click, {
      contributor_name: this.element.getAttribute('data-contributor-name'),
    });
  }
}
